import { AdministratorDto } from '@/src/models/AdministratorDto';

export type PushAlarmType = 'instant' | 'reservation';
export type PushAlarmContentCategory =
  | 'notice'
  | 'magazine'
  | 'entry'
  | 'donation';

export type PushProgressStatus = 'inProgress' | 'scheduled' | 'completed';

export class PushAlarmInfoDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  pushAlarmType: PushAlarmType;
  pushAlarmTitle: string;
  pushAlarmContent: string;
  payload: string;
  contentTitle: string;
  reservationTime: string;
  pushAlarmContentCategory: PushAlarmContentCategory;
  pushAlarmContentId: number;
  pushCategoryType: string;
  pushAppPageConnectionCategory: string;
  pushProgressStatus: PushProgressStatus;
  pushAlarmTotalCount: number;
  pushAlarmSuccessCount: number;
  pushAlarmInformationSuccessPercent: number;
  administrator: AdministratorDto;
}
